import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import { Flag } from "scmp-app/components/common/loading/wheel-icon/styles";

export const Container = styled.div`
  position: relative;

  block-size: 100%;
`;

export const Title = styled.div`
  color: #000000;
  font-size: 32px;
  font-family: ${fontRobotoCondensed};
  line-height: 100%;
`;

export const Filter = styled.div`
  block-size: 24px;
  margin-block: 28px 16px;
  margin-inline-end: 24px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  max-block-size: calc(100vh - 333px);
  padding-inline-end: 12px;

  overflow: hidden auto;
`;

export const StyledLoading = styled(Loading)`
  margin-block: 40px;

  ${Flag} {
    &::before,
    &::after {
      background-color: #f7f6ef;
    }
  }
`;

export const EmptyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  inline-size: 275px;
  margin-block: 32px;
  margin-inline: auto;
`;

export const EmptyListTitle = styled.div`
  font-weight: 700;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-align: center;
`;
export const EmptyListSubtitle = styled.div`
  font-weight: 400;
  font-size: 14px;
`;
